export function popups() {
  let popupFlag = 0;


  $('.popup-show').each(function(index, el) {
    $(el).on('click',  function(event) {
      event.preventDefault();
      popupFlag = 1;
      popupShow(el)
    });
  });

  $(document).on('click', '.popup-close', function(event) {
    event.preventDefault();
    popupHide();
  });
  
  $(document).mouseup(function (e) {
    if( popupFlag == 1 && $(e.target).closest('.popup-item').length == 0 ){
      popupHide()
      // console.log("popupFlag");
    }
  });

  function popupShow(element){
    let popupWrapper = $('.popup-wrapper');
    let curId = $(element).attr('href').slice(1);
    $("body").addClass('scroll-lock');
    popupWrapper.addClass('active');
    popupWrapper.find('.popup-item').each(function(index, el) {
      if( $(el).attr('id') == curId ){
        $(el).addClass('active').siblings().removeClass('active');
      }
    });
  }

  function popupHide(){
    popupFlag = 0;
    $("body").removeClass('scroll-lock');
    $('.popup-wrapper').removeClass('active');
    $('.popup-wrapper .popup-item').removeClass('active');
  }

}


// WEBPACK FOOTER //
// ./assets/js/modules/pupup.js